/**
 * validates if flight status is baggage status
 * @param {string} status
 * @returns {boolean}
 */
export const validateBaggageState = (status: string): boolean => {
  const baggageStatus = false;

  const BAGGAGE_STATUS = [
    "baggage delivery",
    "Gepäckausgabe",
    "托运行李领取",
    "baggage delivery finished",
    "Gepäckausgabe beendet",
    "托运行李领取已结束",
  ];

  return BAGGAGE_STATUS.includes(status);
};
